import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify"
import axios from "axios";

export function TaskDeletionModal(props) {

    const [task, setTask] = useState({});
    useEffect(() => {
        setTask(props.task);
    }, [props.task]);

    const deleteData = () => {
        axios.delete(process.env.REACT_APP_API_URL + '/api/tasks/' + task.id).then((d) => {
            toast.success("Gelöscht");
            props.onSubmit();
        }).catch(e => {
            toast.error("Es ist ein Fehler aufgetreten oder du bist für diese Aktion nicht berechtigt. Versuche es erneut oder wende dich an einen Administrator.",{autoClose: 5500});
            props.onSubmit();
        });
    }

    return <>
        <Modal
            show={props.show}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={props.onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Task löschen
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Bist du dir sicher dass du diesen Task löschen möchtest?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={deleteData}>Ja, Task löschen</Button>
                <Button variant="default " onClick={props.onHide}>Nein, Task nicht löschen</Button>
            </Modal.Footer>

        </Modal>
    </>
}
